<template>
    <TableLaborLogs></TableLaborLogs>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const TableLaborLogs = defineAsyncComponent(() =>
    import("../../components/Hr/LaborLogs/Table.vue")
);

export default {
    name: "Labor_logs",
    components: { TableLaborLogs, AuthLayout },
};
</script>
